(function() {
  'use strict';

  try {
    // ============================================
    // CONFIGURATION - Default values
    // ============================================
    const CONFIG = {
      // Feature toggles
      enableSpyBlock: true,
      enableLanguageBlock: false,
      enableTimezoneBlock: true,
      enableTeamAccess: false,

      // Block settings
      blockDuration: 5 * 60 * 1000,        // 5 minutes in milliseconds
      redirectPage: '/pages/not-found',
      debugMode: false,

      // Data lists (can be overridden via theme settings)
      forbiddenReferrers: [
        'spy', 'adspy', 'pipiads', 'spybadao', 'minea',
        'bigspy', 'adclarity', 'spypro', 'afterlib',
        'shoprunner', 'hunter', 'winning', 'baidu.com',
        'app.afterlib.com', 'adscalp', 'aqiads', 'ppspy',
        'minea.com', 'minea.cn', 'www.minea.com', 'www.minea.cn',
        'app.minea.com', 'app.minea.cn', 'm.minea.com', 'm.minea.cn'
      ],
      forbiddenUserAgents: [
        'adspy', 'pipiads', 'minea', 'bigspy',
        'wget', 'curl', 'axios', 'python-requests', 'httpclient'
      ],
      allowedBots: [
        'googlebot', 'bingbot', 'slurp', 'duckduckbot', 'baiduspider',
        'yandexbot', 'facebot', 'facebookexternalhit', 'gptbot',
        'claudebot', 'anthropic-ai', 'applebot', 'perplexity'
      ],
      // Default blocked languages (ISO 639-1 codes)
      // These languages are blocked because they are commonly associated with scam traffic
      // NOT because they are bots - real users with these browser languages may be blocked
      blockedLanguages: [
        'hi', 'hi-in',      // Hindi (India)
        'ur', 'ur-pk',      // Urdu (Pakistan)
        'bn', 'bn-bd', 'bn-in',  // Bengali (Bangladesh/India)
        'fil', 'fil-ph',    // Filipino (Philippines)
        'tl', 'tl-ph',      // Tagalog (Philippines)
        'vi', 'vi-vn'       // Vietnamese (Vietnam - high scam risk)
      ],
      excludedRegions: [
        // Chinese regions excluded from blocking
        // (Note: Chinese is no longer in blockedLanguages by default)
        'zh-cn', 'zh-sg', 'zh-my', 'zh-tw', 'zh-hant', 'zh-hans-cn'
      ],
      // Default blocked timezones (IANA identifiers)
      // Block all China mainland timezones (excluding Hong Kong, Macau, Taiwan)
      blockedTimezones: [
        // China mainland - UTC+8 (Beijing Time)
        'Asia/Shanghai',     // Shanghai, Beijing, Guangzhou, Shenzhen
        'Asia/Harbin',       // Harbin (same as Shanghai)
        'Asia/Chongqing',    // Chongqing (same as Shanghai)
        // China mainland - UTC+6 (Xinjiang Time)
        'Asia/Urumqi',       // Urumqi, Xinjiang
        'Asia/Kashgar',      // Kashgar, Xinjiang
        // High scam risk regions
        'Asia/Kolkata',      // India
        'Asia/Karachi',      // Pakistan
        'Asia/Dhaka',        // Bangladesh
        'Asia/Manila',       // Philippines
        'Asia/Ho_Chi_Minh'   // Vietnam
      ],
      // Excluded regions (will NOT be blocked even if timezone matches)
      excludedTimezones: [
        'Asia/Hong_Kong',    // Hong Kong
        'Asia/Macau',        // Macau
        'Asia/Taipei',       // Taiwan
        'Asia/Tainan',       // Tainan, Taiwan
        'Asia/Taichung'      // Taichung, Taiwan
      ]
    };

    // ============================================
    // Load settings from Shopify Theme Settings
    // ============================================
    function loadThemeSettings() {
      if (typeof window === 'undefined' || !window.shopifyThemeSettings) {
        return;
      }

      const settings = window.shopifyThemeSettings;

      // Feature toggles
      if (typeof settings.enableSpyBlock !== 'undefined') {
        CONFIG.enableSpyBlock = settings.enableSpyBlock;
      }
      if (typeof settings.enableLanguageBlock !== 'undefined') {
        CONFIG.enableLanguageBlock = settings.enableLanguageBlock;
      }
      if (typeof settings.enableTimezoneBlock !== 'undefined') {
        CONFIG.enableTimezoneBlock = settings.enableTimezoneBlock;
      }
      if (typeof settings.enableTeamAccess !== 'undefined') {
        CONFIG.enableTeamAccess = settings.enableTeamAccess;
      }

      // Block settings
      if (typeof settings.blockDuration === 'number') {
        CONFIG.blockDuration = settings.blockDuration * 60 * 1000;
      }
      if (typeof settings.blockRedirectPage === 'string') {
        CONFIG.redirectPage = settings.blockRedirectPage;
      }
      if (typeof settings.blockDebugMode !== 'undefined') {
        CONFIG.debugMode = settings.blockDebugMode;
      }

      // Custom blocked languages - only override if "Use custom language block list" is enabled
      // When disabled (default), uses the built-in safe defaults
      if (typeof settings.useCustomLanguageBlock !== 'undefined' && settings.useCustomLanguageBlock) {
        if (typeof settings.blockedLanguages === 'string' && settings.blockedLanguages.trim().length > 0) {
          CONFIG.blockedLanguages = settings.blockedLanguages
            .split(',')
            .map(s => s.trim().toLowerCase())
            .filter(s => s.length > 0);
        }

        if (typeof settings.excludedRegions === 'string' && settings.excludedRegions.trim().length > 0) {
          CONFIG.excludedRegions = settings.excludedRegions
            .split(',')
            .map(s => s.trim().toLowerCase())
            .filter(s => s.length > 0);
        }
      }

      // Custom blocked timezones - only override if "Use custom timezone block list" is enabled
      if (typeof settings.useCustomTimezoneBlock !== 'undefined' && settings.useCustomTimezoneBlock) {
        if (typeof settings.blockedTimezones === 'string' && settings.blockedTimezones.trim().length > 0) {
          CONFIG.blockedTimezones = settings.blockedTimezones
            .split(',')
            .map(s => s.trim())
            .filter(s => s.length > 0);
        }

        if (typeof settings.excludedTimezones === 'string' && settings.excludedTimezones.trim().length > 0) {
          CONFIG.excludedTimezones = settings.excludedTimezones
            .split(',')
            .map(s => s.trim())
            .filter(s => s.length > 0);
        }
      }
    }

    loadThemeSettings();

    // ============================================
    // Performance optimization: Convert to Sets (after settings loaded)
    // ============================================
    const forbiddenReferrersSet = new Set(CONFIG.forbiddenReferrers);
    const forbiddenUserAgentsSet = new Set(CONFIG.forbiddenUserAgents);
    const allowedBotsSet = new Set(CONFIG.allowedBots.map(ua => ua.toLowerCase()));
    const blockedLanguagesSet = new Set(CONFIG.blockedLanguages);
    const excludedRegionsSet = new Set(CONFIG.excludedRegions);
    const blockedTimezonesSet = new Set(CONFIG.blockedTimezones);
    const excludedTimezonesSet = new Set(CONFIG.excludedTimezones);

    // ============================================
    // Team Access Check
    // ============================================
    function getAllowedAccessParams() {
      if (window.shopifyThemeSettings && window.shopifyThemeSettings.accessParameters) {
        return window.shopifyThemeSettings.accessParameters
          .split(' ')
          .map(p => p.trim())
          .filter(p => p.length > 0);
      }
      return ['member', 'team'];
    }

    function checkTeamAccess() {
      // Check URL parameter first
      const urlParams = new URLSearchParams(window.location.search);
      const accessParam = urlParams.get('access');
      const allowedParams = getAllowedAccessParams();

      if (accessParam && allowedParams.includes(accessParam)) {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);
        document.cookie = `team_access=granted; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
        return true;
      }

      // Check cookie
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'team_access' && value === 'granted') {
          return true;
        }
      }

      // Check theme setting override
      if (CONFIG.enableTeamAccess) {
        return true;
      }

      return false;
    }

    // Bypass all checks for team members
    if (checkTeamAccess()) {
      if (CONFIG.debugMode) {
        console.log('[Block] Team member access detected - bypassing all blocks');
      }
      return;
    }

    // ============================================
    // Skip redirect page
    // ============================================
    if (window.location.pathname.includes(CONFIG.redirectPage)) {
      return;
    }

    // ============================================
    // Detection Functions
    // ============================================

    /**
     * Check if referrer matches any forbidden patterns
     * @param {string} referrer - The referrer URL
     * @returns {boolean}
     */
    function isBadReferrer(referrer) {
      const ref = referrer.toLowerCase();

      // Fast path: exact domain match
      for (const keyword of forbiddenReferrersSet) {
        if (ref.includes(keyword)) {
          return true;
        }
      }

      return false;
    }

    /**
     * Check if user agent matches any forbidden patterns
     * @param {string} userAgent - The browser user agent
     * @returns {boolean}
     */
    function isBadUserAgent(userAgent) {
      const ua = userAgent.toLowerCase();

      for (const keyword of forbiddenUserAgentsSet) {
        if (ua.includes(keyword)) {
          return true;
        }
      }

      return false;
    }

    /**
     * Check if user agent is an allowed search bot
     * @param {string} userAgent - The browser user agent
     * @returns {boolean}
     */
    function isAllowedBot(userAgent) {
      const ua = userAgent.toLowerCase();

      for (const bot of allowedBotsSet) {
        if (ua.includes(bot)) {
          return true;
        }
      }

      return false;
    }

    /**
     * Check if browser language is blocked
     * @param {string} primaryLang - Primary language code
     * @param {string[]} allLangs - All language codes
     * @returns {boolean}
     */
    function isForbiddenLanguage(primaryLang, allLangs) {
      const lang = primaryLang.toLowerCase();
      const langs = allLangs.map(l => l.toLowerCase());

      // Check primary language
      for (const code of blockedLanguagesSet) {
        if (lang === code || lang.startsWith(code + '-')) {
          // Check if this is an excluded region
          for (const excluded of excludedRegionsSet) {
            if (lang === excluded || lang.startsWith(excluded + '-')) {
              return false;
            }
          }
          return true;
        }
      }

      // Check all languages
      for (const l of langs) {
        for (const code of blockedLanguagesSet) {
          if (l === code || l.startsWith(code + '-')) {
            // Check if this is an excluded region
            let isExcluded = false;
            for (const excluded of excludedRegionsSet) {
              if (l === excluded || l.startsWith(excluded + '-')) {
                isExcluded = true;
                break;
              }
            }
            if (!isExcluded) {
              return true;
            }
          }
        }
      }

      return false;
    }

    /**
     * Check if timezone is blocked
     * @param {string} timezone - IANA timezone string
     * @returns {boolean}
     */
    function isForbiddenTimezone(timezone) {
      if (!CONFIG.enableTimezoneBlock) {
        return false;
      }

      // Check if timezone is in the excluded list first
      if (excludedTimezonesSet.has(timezone)) {
        return false;
      }

      // Check if timezone is in the blocked list
      return blockedTimezonesSet.has(timezone);
    }

    // ============================================
    // Main Detection Logic
    // ============================================

    const ref = document.referrer.toLowerCase();
    const ua = navigator.userAgent.toLowerCase();
    const lang = navigator.language ? navigator.language.toLowerCase() : '';
    const langs = navigator.languages ? navigator.languages.map(l => l.toLowerCase()) : [];

    // Spy tool detection
    const shouldBlockSpy = CONFIG.enableSpyBlock &&
      (isBadReferrer(ref) || isBadUserAgent(ua));

    // Language detection
    const shouldBlockLanguage = CONFIG.enableLanguageBlock &&
      isForbiddenLanguage(lang, langs);

    // Timezone detection
    let shouldBlockTimeZone = false;
    try {
      if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        shouldBlockTimeZone = isForbiddenTimezone(timezone);
      }
    } catch (e) {
      // Intl not available, skip timezone check
    }

    // Check if allowed bot (always bypass)
    if (isAllowedBot(ua)) {
      if (CONFIG.debugMode) {
        console.log('[Block] Allowed bot detected - bypassing');
      }
      return;
    }

    // ============================================
    // Block Persistence Check
    // ============================================

    const now = Date.now();
    let blockedTime = 0;

    try {
      blockedTime = parseInt(localStorage.getItem('blocked'), 10) || 0;
    } catch (e) {
      blockedTime = 0;
    }

    // If within block duration, redirect
    if (blockedTime && now - blockedTime < CONFIG.blockDuration) {
      window.location.href = CONFIG.redirectPage + '?t=' + blockedTime;
      return;
    }

    // ============================================
    // Final Decision
    // ============================================

    const shouldBlock = shouldBlockSpy || shouldBlockLanguage || shouldBlockTimeZone;

    if (CONFIG.debugMode) {
      console.log('[Block] Detection results:', {
        spy: shouldBlockSpy,
        language: shouldBlockLanguage,
        timezone: shouldBlockTimeZone,
        finalDecision: shouldBlock
      });
    }

    // Apply block
    if (shouldBlock) {
      try {
        localStorage.setItem('blocked', now.toString());
      } catch (e) {
        // localStorage not available
      }

      window.location.href = CONFIG.redirectPage + '?t=' + now;
    }

  } catch (e) {
    console.warn('[Block] Script error:', e);
  }
})();
